// apps/web/src/lib/pagerBridge.ts
// 물리키 페이지 네비게이션을 위한 브릿지

type PagerHandlers = {
    next?: () => void;
    prev?: () => void;
    first?: () => void;
    last?: () => void;
};

let currentPager: PagerHandlers | null = null;

// 페이지에서 마운트 시 호출 - 자신의 pager 함수 등록
export function registerPager(handlers: PagerHandlers) {
    currentPager = handlers;
}

// 페이지에서 언마운트 시 호출 - pager 함수 해제
export function unregisterPager() {
    currentPager = null;
}

// 전역 함수 설치 (앱 시작 시 한 번 호출)
export function installPagerBridge() {
    if (typeof window === "undefined") return;

    (window as any).__booktox_pageNext = () => {
        if (currentPager?.next) {
            currentPager.next();
            return true;
        }
        return false;
    };

    (window as any).__booktox_pagePrev = () => {
        if (currentPager?.prev) {
            currentPager.prev();
            return true;
        }
        return false;
    };

    (window as any).__booktox_pageFirst = () => {
        if (currentPager?.first) {
            currentPager.first();
            return true;
        }
        return false;
    };

    (window as any).__booktox_pageLast = () => {
        if (currentPager?.last) {
            currentPager.last();
            return true;
        }
        return false;
    };
}

// TypeScript 전역 타입 선언
declare global {
    interface Window {
        __booktox_pageNext?: () => boolean;
        __booktox_pagePrev?: () => boolean;
        __booktox_pageFirst?: () => boolean;
        __booktox_pageLast?: () => boolean;
    }
}
